import { useQuery } from "@tanstack/vue-query";
import type Zod from "zod";

import type { TextId } from "@/types/global.ts";
import { withProblemError } from "@/utils/api-error.ts";

export function useProfileById(
	params: MaybeRef<Zod.infer<typeof TextId>>,
	options?: { enabled?: boolean },
) {
	const api = useApiClient();

	return useQuery({
		enabled: options?.enabled,
		retry: false,
		queryKey: ["get-profile-by-id", params] as const,
		async queryFn({ queryKey: [, params] }) {
			const response = await withProblemError(
				api.vicav.getProfile({ id: params.textId }, { headers: { accept: "application/xml" } }),
			);
			return response.text();
		},
	});
}
